import styles from './Slider.module.scss';

import { Slider as DefaultSlider } from '@/components/Slider';
import { useOpinionContext } from '@/modules/opinions';
import cn from 'classnames';

import { UserThumb } from '../UserThumb';

type SliderProps = {
  isLoading: boolean;
  onDragEnd: () => void;
};

export const Slider = (props: SliderProps) => {
  const { isVoted, setSliderValue, setIsDragEnded, sliderValue, opinion } =
    useOpinionContext();

  const onDragEnd = () => {
    setIsDragEnded(true);
    props.onDragEnd?.();
  };

  return (
    <div className={cn(styles.slider, 'sliderRef')}>
      <UserThumb />
      <DefaultSlider
        isLoading={false}
        onDragEnd={onDragEnd}
        value={sliderValue}
        onChange={setSliderValue}
        maxValue={100}
        trackHeight={18}
        disabled={isVoted}
      >
        {isVoted && (
          <span className={styles.actualPercentage}>
            {Math.min(Math.round(opinion.actualPercentage), 100)}%
          </span>
        )}
      </DefaultSlider>
    </div>
  );
};
